import * as React from 'react';
import { ListingState, BaseRouteProps } from '../../../interfaces';
import { ScoreCard } from '../../../models';
import { ScoreCardDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { LoadingIndicatorMini, PVAPage, DataGrid } from '../../../components';
import { Button } from 'react-bootstrap';
import { LoadingIndicator } from '../../loadingIndicator/LoadingIndicator';

interface ScoreCardListingState extends ListingState<ScoreCard> {
    copyingScoreCard: boolean;
}

export class ScoreCardListing extends React.Component<BaseRouteProps<{}>, ScoreCardListingState> {
    private scoreCardDataService = new ScoreCardDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            entities: new Array<ScoreCard>(),
            copyingScoreCard: false
        };
    }

    public componentDidMount() {
        this.scoreCardDataService.getAll().then((scoreCards: ScoreCard[]) => {
            this.setState(
                { entities: scoreCards }
            );
        });
    }

    public copyScoreCard(scoreCardId: number) {
        this.setState({ copyingScoreCard: true });

        this.scoreCardDataService.copy(scoreCardId)
            .then((scoreCard: ScoreCard) => {
                this.props.history.push(`/scorecards/${scoreCard.id}`);
            })
            .catch(() => this.props.notificationService.addError('Error copying score card. Please try again.'));
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name,
                'Organization': entity.organization.name,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <div className="buttons-row">
                    <Button className="btn btn-default" onClick={() => this.copyScoreCard(value)}>Copy</Button>
                    &nbsp;&nbsp;
                    <NavLink className="btn btn-default" to={`/scorecards/${value}`}>View</NavLink>
                </div>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'Organization' },
            { id: 'ActionKey', title: 'Actions', width: '150px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        Score Cards
                    </PVAPage.Header.Title>
                    <PVAPage.Header.Buttons>
                        <NavLink className="btn btn-primary" to="/scorecards/create">
                            <span className="glyphicon glyphicon-plus" /> Create
                        </NavLink>
                    </PVAPage.Header.Buttons>
                </PVAPage.Header>

                <PVAPage.Body>
                    { this.state.copyingScoreCard && 
                        <LoadingIndicator showBackground={true} /> 
                    }
                    
                    <DataGrid entities={listData} columns={columnDefs} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCard/ScoreCardListing.tsx